import { Document as ContentfulDocument } from "@contentful/rich-text-types";

// eslint-disable-next-line
const contentful = require("contentful");

const SPACE = "7rp7y0gd6s4x";
const ENVIRONMENT = "master";

const client = contentful.createClient({
  space: SPACE,
  environment: ENVIRONMENT,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_DELIVERY_API_KEY as string
});

// eslint-disable-next-line
export interface Document extends ContentfulDocument {}

interface File {
  contentType: string;
  filename: string;
  url: string;
}

interface Asset {
  fields: {
    title: string;
    description: string;
    file: File;
  };
}

interface Author {
  fields: { name: string };
}

interface PostBaseFields {
  title: string;
  //   body: string;
  slug: string;
  body: Document;
  description: string;
  thumbnail: Asset;
  author: Author;
}

export interface Post {
  sys: { id: string; createdAt: string; updatedAt: string };
  metadata: {
    tags: Array<{
      sys: {
        id: string;
      };
    }>;
  };
  fields: PostBaseFields;
}

export interface Tag {
  name: string;
  sys: {
    id: string;
  };
}

export async function getPosts(options: { [name: string]: string } = {}) {
  const res = await client.getEntries({ content_type: "post", ...options });
  return res.items;
}

export async function getPostById(id: string) {
  const res = await client.getEntry(id);
  return res;
}

export async function getPostBySlug(slug: string) {
  const res = await client.getEntries({
    limit: 1,
    content_type: "post",
    "fields.slug": slug
  });
  return res && res.items.length ? res.items[0] : undefined;
}

export async function getTags() {
  const res = await client.getTags();
  return res;
}

export async function getTag(id: string) {
  const res = await client.getTag(id);
  return res;
}
